import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const repairTicketRoutes: RouteObject[] = [
  {
    path: '/repair-ticket',
    element: lazyElement(() => import('./Main')),
    handle: {
      documentTitle: 'Repair Tickets',
      crumb: () => ({ label: 'Repair Tickets', to: '/repair-ticket' }),
    },
  },
  {
    path: '/repair-ticket/view/:id',
    element: lazyElement(() => import('./View')),
    handle: { crumb: () => ({ label: 'Repair Ticket' }) },
  },
  {
    path: '/repair-ticket/print/:id',
    element: lazyElement(() => import('./Print')),
    handle: { crumb: () => ({ label: 'Print' }) },
  },
];

export default repairTicketRoutes;
